"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopyToClipboard = void 0;
// code based on usehooks-ts
const react_1 = require("react");
const useCopyToClipboard = () => {
    const [copiedText, setCopiedText] = (0, react_1.useState)(null);
    const copyToClipboard = async (text) => {
        if (!navigator?.clipboard) {
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        }
        catch (error) {
            setCopiedText(null);
            return false;
        }
    };
    return { copiedText, copyToClipboard };
};
exports.useCopyToClipboard = useCopyToClipboard;
//# sourceMappingURL=useCopyToClipboard.js.map